<template>
  <a-modal
    title="返现任务管理"
    width="80%"
    :visible="open"
    :footer="null"
    v-highlight
    @cancel="onClose"
    :bodyStyle="{ height: '500px'}"
  >
    <!-- 操作 -->
    <div class="table-operations" v-show="status === 0">
      <a-button type="primary" @click="$refs.createRebateActivityTask.handleAdd(queryParam.activityId)" v-hasPermi="['played:rebate/task:add']" :disabled="status !== 0">
        <a-icon type="plus" />新增
      </a-button>
      <a-button type="primary" :disabled="single" @click="$refs.createRebateActivityTask.handleUpdate(undefined, ids, queryParam.activityId)" v-hasPermi="['played:rebate/task:edit']">
        <a-icon type="edit" />修改
      </a-button>
      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:rebate/task:remove']">
        <a-icon type="delete" />删除
      </a-button>
      <table-setting
        :style="{float: 'right'}"
        :table-size.sync="tableSize"
        v-model="columns"
        :refresh-loading="loading"
        @refresh="getList" />
    </div>
    <CreateRebateActivityTask
      ref="createRebateActivityTask"
      @ok="getList"
    />
    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record" v-show="status === 0">
        <a @click="$refs.createRebateActivityTask.handleUpdate(record, undefined, queryParam.activityId)" v-hasPermi="['played:rebate/task:edit']">
          <a-icon type="edit" />修改
        </a>
        <a-divider type="vertical" v-hasPermi="['played:rebate/task:remove']" />
        <a @click="handleDelete(record)" v-hasPermi="['played:rebate/task:remove']">
          <a-icon type="delete" />删除
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      :show-quick-jumper="false"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import OssMultiUploadSingle from '@/views/script/script/modules/OssMultiUploadSingle.vue'
import { delRebateActivityTask, listRebateActivityTask } from '@/api/played/rebateActivity'
import { tableMixin } from '@/store/table-mixin'
import CreateRebateActivityTask from './CreateRebateActivityTask'

export default {
  name: 'RebateActivityTask',
  props: {
  },
  components: {
    CreateRebateActivityTask,
    OssMultiUploadSingle,
    OssMultiUpload,
    IndexScriptModal
  },
  mixins: [tableMixin],
  data () {
    return {
      status: undefined,
      loading: false,
      list: [],
      total: 0,
      // 查询参数
      queryParam: {
        activityId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '活动名称',
          dataIndex: 'activityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务编号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '需要完成的场次',
          dataIndex: 'requiredCount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '返现金额',
          dataIndex: 'rebateAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '限制领取次数(0表示不限次数)',
          dataIndex: 'limitCount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList() {
      this.loading = true
      listRebateActivityTask(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onClose () {
      this.open = false
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleRebateTask (row) {
      this.open = true
      this.status = row.status
      this.queryParam = {
        activityId: row.id,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delRebateActivityTask(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
